export const containsInsensitive = (stringToContain: string, partialString: string) =>
  stringToContain.toLowerCase().includes(partialString.toLowerCase());
